import axios from "axios";

const axiosGoogleToken = (history = null) => {
  const baseUrl = process.env.REACT_APP_GOOGLESIGNIN_TOKEN;
   
  const axiosInstance = axios.create({
    baseURL: baseUrl
  });

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, _reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((_resolve, reject) => {
          reject(error);
        });
      }

      if (error.response.status === 403 || error.response.status === 401) {   
        let path = window.location.pathname; 
        if (history) {
          if(path !== "/") history.push("/");
        } else {
          if(path !== "/") window.location = "/";
        }
      } else {
        return new Promise((_resolve, reject) => {
          reject(error);
        });
      }
    }
  );
  return axiosInstance;
};

export default axiosGoogleToken;